import Modal from "../Modal";
import styles from "./ModalCommon.module.scss";
import { FiX } from "react-icons/fi";

const ModalCommon = ({
  setModalOpen,
  titleImg,
  title = "",
  children,
  bigTitle,
  darkBg,
  whiteBg,
  blur,
  blockExit,
  style,
}) => {
  return (
    <Modal
      setModalOpen={setModalOpen}
      center
      darkBg={darkBg}
      whiteBg={whiteBg}
      blockExit={blockExit}
    >
      <div
        className={`${styles.wrap} ${blur ? styles.blur : ""}`}
        style={{ ...style }}
      >
        <div className={styles.header}>
          {bigTitle && <div />}
          <div className={bigTitle ? styles.bigTitle : styles.title}>
            {titleImg ? <img src={titleImg} alt="modal title img" /> : ""}
            {title}
          </div>
          {!blockExit && (
            <FiX
              onClick={() => setModalOpen(false)}
              style={{
                fontSize: bigTitle ? 28 : "",
                paddingTop: bigTitle ? 15 : "",
              }}
            />
          )}
        </div>
        <div>{children}</div>
      </div>
    </Modal>
  );
};

export default ModalCommon;
